import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { ErrorDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ErrorDialog";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessPublishPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessPublishProperties = {
    [name in keyof EntityCommandProcessPublishPropertyValues]: Property<EntityCommandProcessPublishPropertyValues[name]>
};

export interface IEntityCommandProcessPublish extends IEntityCommand, EntityCommandProcessPublishProperties
{
}

export class EntityCommandProcessPublish extends EntityCommand implements IEntityCommandProcessPublish
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessPublish";
    public static override className = "EntityCommandProcessPublish";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessPublishPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Publish",
                entityName: "Process",
                key: "PUBLISH",
                permission: (PermissionEvaluator.permissionLevels.create ?? 0) | (PermissionEvaluator.permissionLevels.read ?? 0),
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessPublishPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        record = entityCommandInformation.record.get();

                    if (!record || !record.id)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest(
                                "DataService",
                                "CallDataService",
                                {
                                    id: "b185975f-0e14-4944-b706-6353f0d67dc4",
                                    operation: "PublishProcess",
                                    data: ObjectHelper.toJson({
                                        processId: record.id,
                                        rowVersion: record.rowVersion ? record.rowVersion : null,
                                        isStartable: true,
                                        isDefault: true,
                                        retireOtherVersions: true
                                    })
                                }
                            )
                            .executeAsync()
                            .then(data =>
                            {
                                return (
                                    MessageDialog
                                        .displayMessage("Publish Successful", StringHelper.format("The process has been published: v{0}.{1}", data.major, data.minor), ButtonStyleEnum.okOnly)
                                );
                            })
                            .catch(error =>
                            {
                                ErrorDialog.displayError("Unable to publish the process");
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

